import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A roadtrip: wherein Swizec is not to be trusted with important objects without supervision",
  "description": "",
  "published": "2012-07-29T00:00:00.000Z",
  "redirect_from": ["/blog/a-roadtrip-wherein-swizec-is-not-to-be-trusted-with-important-objects-without-supervision/swizec/4923"],
  "categories": "Croatia, Roadtrip, Tourism, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/07/mala-panorama-omis-blog.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/07/mala-panorama-omis-blog.jpg",
          "alt": "Omiš panorama",
          "title": "Omiš panorama"
        }}></img></a></p>
    <p><em parentName="p">{`This is a guestpost brought to you by the patient `}<a parentName="em" {...{
          "href": "http://twitter.com/ponywithhiccups"
        }}>{`@ponywithhiccups`}</a></em></p>
    <p>{`It was day two of our roadtrip, we just bought spare circuit-breakers for the "scary" house, went `}<a parentName="p" {...{
        "href": "http://tz-omis.hr/content/view/56/72/lang,hr/"
      }}>{`sight-seeing`}</a>{`, bought some food and had our daily dose of internets. I was just thinking how everything was going to work out money-wise; especially if there woudn't be any emergencies.`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage6.instagram.com/b5debbfad96611e1b00112313800c5e4_7.jpg",
        "alt": "Omiš from Pirate Fortress",
        "title": "Omiš from Pirate Fortress"
      }}></img></p>
    <p>{`Everything was going well.`}</p>
    <p>{`Until we got to the car, where it became painfully obvious that I am traveling with an idiot. Or a child. Or idiot child.`}</p>
    <p>{`"Where are the car keys? Did I put them in your bag?"`}</p>
    <p>{`No he did not.`}</p>
    <p>{`And he did not put them in his bag either.`}</p>
    <p>{`He put them in his pants pocket, with the stuffed toy keychain hanging out. Pants that are too big, too loose, and any time he sits down pens and coins fall out immediately and silently ...`}</p>
    <p>{`You see where this is going ...`}</p>
    <p><strong parentName="p">{`He lost the damned keys!`}</strong>{` The only car keys we had! The only keys for this car in existence. ~450 km from home, 7 km from the "scary" house. Probably the only thing we're not supposed to lose.`}</p>
    <h2 {...{
      "id": "now-what"
    }}>{`Now what?`}</h2>
    <p>{`I had two options: I could have yelled at him, or we could have calmly retraced our steps.`}</p>
    <p>{`Option one was pointless, so we walked back slowly in the hot summer day. After we asked in everywhere we've been and haven't been and looked everywhere - even on the pirate fortress - it was obvious that we are in fact royally screwed.`}</p>
    <p>{`We looked for the keys two more times, went to the police station. There was a suprising amount of found keys, but not the sheep keychain kind. :(`}</p>
    <p>{`There's not much one can do without car keys in a foreign country. Even the friendly police officer was not sure what to do.`}</p>
    <p>{`Our options were basically:`}</p>
    <ol>
      <li parentName="ol">{`you can hope and look for the keys some more`}</li>
      <li parentName="ol">{`you can break in (it is surprisingly easy to find someone who can do that), but the car will remain unlocked and stationary`}</li>
      <li parentName="ol">{`sem-legally get a new key and hope it can start the car`}</li>
      <li parentName="ol">{`go to your car dealership about 30 km away and hope for magic`}</li>
    </ol>
    <p>{`Oh yeah ... it's also the weekend! Fun!`}</p>
    <p>{`Day two of the roadtrip to the seaside and we haven't even been to the beach yet! We had to return the rafting ticket we bought just hours before, too.`}</p>
    <p>{`Day two was going even less according to plan than day one. Achievement unlocked?`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage8.instagram.com/4dc8013cd96811e194471231380ff9db_7.jpg",
        "alt": "The missing sheepy",
        "title": "The missing sheepy"
      }}></img></p>
    <p>{`After about 3 or 4 hours we gave up and hitched a ride back to the village. There was nothing else we could do here. Luckily, hitchin' a ride is fairly easy around here - many young people do it to get to the beach.`}</p>
    <p>{`Once back at the village we asked our awesome neighbours for help. Got a few phone noumbers, made some calls and then ... waited.`}</p>
    <p>{`The next morning, still no keys at the police station. The car dealership wasn't answering the phone either. Saturday. :( Many angry/worried calls from mom.`}</p>
    <p>{`All in all a shitty day.`}</p>
    <p>{`Saturday evening came and the neighbours returned from town with some promising news! There were keys similar to ours in the little parking lot hut!`}</p>
    <p>{`Today we had a nervous car ride to Omiš. We really do have great neighbours.`}</p>
    <p>{`It `}<em parentName="p">{`was`}</em>{` our car keys! Hooray! Everything worked out (better than expected?). I love that little stuffed toy key chain sheepy!`}</p>
    <p>{`... and let's just say I'll be carrying the keys from now on.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://robertbasic.com/blog/ljubljana-slovenia"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/102172824_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://robertbasic.com/blog/ljubljana-slovenia"
        }}>{`Ljubljana, Slovenia`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://e2e.ti.com/blogs_/b/aroundti/archive/2012/07/25/39-roadtrip-nation-39-makes-a-stop-at-ti.aspx"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_15_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://e2e.ti.com/blogs_/b/aroundti/archive/2012/07/25/39-roadtrip-nation-39-makes-a-stop-at-ti.aspx"
        }}>{`Blog Post: 'Roadtrip Nation' makes a stop at TI`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.sippycupchronicles.com/2012/06/roadtrip-matic-makes-planning-road-trip.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/93339089_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.sippycupchronicles.com/2012/06/roadtrip-matic-makes-planning-road-trip.html"
        }}>{`Roadtrip-A-Matic Makes planning a Road Trip to Pennsylvania a Snap`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=61e00912-b607-4d64-ae11-c9523bf9844d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      